/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_Import_Audio_Extraction_CompleteInputs */

const en_team_project_import_audio_extraction_complete = /** @type {(inputs: Team_Project_Import_Audio_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio extraction completed successfully.`)
};

const fr_team_project_import_audio_extraction_complete = /** @type {(inputs: Team_Project_Import_Audio_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraction audio terminée avec succès.`)
};

const de_team_project_import_audio_extraction_complete = /** @type {(inputs: Team_Project_Import_Audio_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Audioextraktion wurde erfolgreich abgeschlossen.`)
};

const it_team_project_import_audio_extraction_complete = /** @type {(inputs: Team_Project_Import_Audio_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrazione audio completata con successo.`)
};

const ru_team_project_import_audio_extraction_complete = /** @type {(inputs: Team_Project_Import_Audio_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Извлечение аудиофайлов успешно завершено.`)
};

const es_team_project_import_audio_extraction_complete = /** @type {(inputs: Team_Project_Import_Audio_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extracción de audio completada exitosamente.`)
};

const zh_cn2_team_project_import_audio_extraction_complete = /** @type {(inputs: Team_Project_Import_Audio_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音频提取成功。`)
};

const ja_team_project_import_audio_extraction_complete = /** @type {(inputs: Team_Project_Import_Audio_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオ抽出が正常に完了しました。`)
};

const hi_team_project_import_audio_extraction_complete = /** @type {(inputs: Team_Project_Import_Audio_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो निष्कर्षण सफलतापूर्वक पूरा हो गया।`)
};

const pt_pt2_team_project_import_audio_extraction_complete = /** @type {(inputs: Team_Project_Import_Audio_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extração de áudio concluída com sucesso.`)
};

/**
* | output |
* | --- |
* | "Audio extraction completed successfully." |
*
* @param {Team_Project_Import_Audio_Extraction_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_audio_extraction_complete = /** @type {((inputs?: Team_Project_Import_Audio_Extraction_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_Audio_Extraction_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_project_import_audio_extraction_complete(inputs)
	if (locale === "de") return de_team_project_import_audio_extraction_complete(inputs)
	if (locale === "it") return it_team_project_import_audio_extraction_complete(inputs)
	if (locale === "ru") return ru_team_project_import_audio_extraction_complete(inputs)
	if (locale === "es") return es_team_project_import_audio_extraction_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_team_project_import_audio_extraction_complete(inputs)
	if (locale === "ja") return ja_team_project_import_audio_extraction_complete(inputs)
	if (locale === "hi") return hi_team_project_import_audio_extraction_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_team_project_import_audio_extraction_complete(inputs)
	return en_team_project_import_audio_extraction_complete(inputs)
});